"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInfectiousDiseaseTestDto = instanceOfInfectiousDiseaseTestDto;
exports.InfectiousDiseaseTestDtoFromJSON = InfectiousDiseaseTestDtoFromJSON;
exports.InfectiousDiseaseTestDtoFromJSONTyped = InfectiousDiseaseTestDtoFromJSONTyped;
exports.InfectiousDiseaseTestDtoToJSON = InfectiousDiseaseTestDtoToJSON;
exports.InfectiousDiseaseTestDtoToJSONTyped = InfectiousDiseaseTestDtoToJSONTyped;
const TestCardFileDto_1 = require("./TestCardFileDto");
const InfectiousDiseaseTestType_1 = require("./InfectiousDiseaseTestType");
/**
 * Check if a given object implements the InfectiousDiseaseTestDto interface.
 */
function instanceOfInfectiousDiseaseTestDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('testDate' in value) || value['testDate'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function InfectiousDiseaseTestDtoFromJSON(json) {
    return InfectiousDiseaseTestDtoFromJSONTyped(json, false);
}
function InfectiousDiseaseTestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'code': (0, InfectiousDiseaseTestType_1.InfectiousDiseaseTestTypeFromJSON)(json['code']),
        'testDate': (new Date(json['testDate'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'isTestDateValid': json['isTestDateValid'] == null ? undefined : json['isTestDateValid'],
        'testCardV2': json['testCardV2'] == null ? undefined : (0, TestCardFileDto_1.TestCardFileDtoFromJSON)(json['testCardV2']),
    };
}
function InfectiousDiseaseTestDtoToJSON(json) {
    return InfectiousDiseaseTestDtoToJSONTyped(json, false);
}
function InfectiousDiseaseTestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'code': (0, InfectiousDiseaseTestType_1.InfectiousDiseaseTestTypeToJSON)(value['code']),
        'testDate': ((value['testDate']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'isTestDateValid': value['isTestDateValid'],
        'testCardV2': (0, TestCardFileDto_1.TestCardFileDtoToJSON)(value['testCardV2']),
    };
}
//# sourceMappingURL=InfectiousDiseaseTestDto.js.map